import React, { useContext } from 'react';
import { css } from '@emotion/react';
import { useSelector } from 'react-redux';
import t from 'react-translate';

import { AngularServicesContext } from 'react-app';
import { updateUser } from 'redux/actions/users';
import { useAppDispatch } from 'redux/store';
import { getCurrentUser } from 'redux/selectors/users';
import { wrapThunkAction } from 'redux/utils';
import { addAlertMessage } from 'redux/actions/alert-messages';
import { AlertMessageType } from 'redux/schemas/app/alert-message';

import NvSwitch from 'shared/components/inputs/nv-switch';
import NvPopover from 'shared/components/nv-popover';
import prodPathReplace from 'shared/prod-path-rewrite';
import { halfSpacing, quarterSpacing } from 'styles/global_defaults/scaffolding';
import { config } from '../../../config/pendo.config.json';

const DisplayTimeZoneInNavSwitch = () => {
  const dispatch = useAppDispatch();

  const {
    CurrentUserManager,
  } = useContext(AngularServicesContext);

  const { displayTimeZoneClock } = useSelector(getCurrentUser);

  const handleChange = (isOn: boolean) => {
    wrapThunkAction(
      dispatch(updateUser({ displayTimeZoneClock: isOn })),
    ).then(() => {
      CurrentUserManager.user.updateFromReact({
        displayTimeZoneClock: isOn,
      });
    }).catch((error) => {
      dispatch(addAlertMessage({
        type: AlertMessageType.ERROR,
        header: t.FORM.OOPS(),
        message: t.FORM.ERROR_SOMETHING_WRONG(),
      }));
    });
  };

  const styles = css`
    gap: ${halfSpacing}px;

    .info-wrapper {
      gap: ${quarterSpacing}px;

      .popover-wrapper {
        display: inline;
        }
    }
  `;

  return (
    <div className='d-flex' css={styles}>
      <NvSwitch
        checked={displayTimeZoneClock}
        className='switch'
        onChange={handleChange}
        enabledLabel={t.SHARED.ON().toUpperCase()}
        disabledLabel={t.SHARED.OFF().toUpperCase()}
        dataQa={config.pendo.accountSettings.languageAndTimezone.displayTimezoneInNav}
      />
      <div className='info-wrapper d-flex flex-column align-items-start'>
        <div>
          {t.ACCOUNT_SETTINGS.LANGS_AND_TZ.DISPLAY_TIME_IN_NAV()}
          &nbsp;
          <NvPopover
            showOnHover
            preventOverflow
            content={(
              <img
                src={prodPathReplace('images/timezone-selector.gif')}
                alt={t.ACCOUNT_SETTINGS.LANGS_AND_TZ.DISPLAY_TIME_IN_NAV_PREVIEW()}
              />
            )}
            overlayStyles={css`
              max-width: 360px;
            `}
          >
            <span className='text-primary'>{t.ACCOUNT_SETTINGS.LANGS_AND_TZ.DISPLAY_TIME_IN_NAV_PREVIEW()}</span>
          </NvPopover>
        </div>
        <div className='label gray-2'>
          {t.ACCOUNT_SETTINGS.LANGS_AND_TZ.DISPLAY_TIME_IN_NAV_INFO()}
        </div>
      </div>
    </div>
  );
};

export default DisplayTimeZoneInNavSwitch;
